import type { SVGProps, FC } from "react"

const SvgSystemPlacement: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 16 15.852"
    fill="currentColor"
    {...props}
  >
    <path d="M15.668 15.632a.935.935 0 0 0 .213-1.172l-2.117-3.766a1.586 1.586 0 0 0-1.361-.6 18.867 18.867 0 0 1-3.332 3.518A1.677 1.677 0 0 1 8 14a1.658 1.658 0 0 1-1.067-.386 18.867 18.867 0 0 1-3.332-3.518 1.581 1.581 0 0 0-1.361.6L.121 14.46a.931.931 0 0 0 .213 1.172.937.937 0 0 0 .6.22h14.134a.935.935 0 0 0 .6-.22Z" />
    <g>
      <path d="M8.001 3.217a1.935 1.935 0 0 0-1.934 1.934.464.464 0 0 0 .928 0 1.012 1.012 0 0 1 1.009-1.009.462.462 0 1 0 0-.924Z" />
      <path d="M13.094 5.093a5.093 5.093 0 0 0-10.158-.494 5.242 5.242 0 0 0 .068 1.463s.01.054.034.159A5.059 5.059 0 0 0 3.38 7.23a14.757 14.757 0 0 0 4.341 5.439.444.444 0 0 0 .566 0 14.73 14.73 0 0 0 4.341-5.439 4.92 4.92 0 0 0 .342-1.009c.024-.1.034-.159.034-.159a4.842 4.842 0 0 0 .09-.969ZM8.001 8.249a3.1 3.1 0 1 1 3.1-3.1 3.1 3.1 0 0 1-3.1 3.1Z" />
    </g>
  </svg>
)

export default SvgSystemPlacement
